(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/matchen/assets/javascripts/views/coupon/coupon.js') >= 0) return;  svs.modules.push('/modules/matchen/assets/javascripts/views/coupon/coupon.js');

'use strict';

svs.matchen.views.Coupon = Marionette.View.extend({
  regions: {
    coupon: '.region-coupon'
  },
  ui: {
    clearBtn: '.js-clear-btn'
  },
  clickClear() {
    this.clearCouponCallback();
  },
  events: {
    'click @ui.clearBtn': 'clickClear'
  },
  className: 'layout-coupon',
  id: 'coupon',
  template(data) {
    return svs.matchen.templates.coupon(data);
  },
  initialize() {
    this.listenTo(this.model, 'change:hasSelections', () => this.updateClearButton());
    $('body').removeClass('bg-oddset-500 matchen-start');
    this.initBetslip();
    this.initActionBarXperten();
    this.initListeners();
  },
  updateClearButton(btn) {
    (btn || this.ui.clearBtn).prop('disabled', !this.model.changed.hasSelections);
  },
  initActionBarXperten() {
    return new svs.matchen.objects.ActionBarXperten({
      clearCouponCallback: this.clearCouponCallback.bind(this),
      model: this.model.get('xperten'),
      refreshXpertenCallback: this.refreshXperten.bind(this),
      showXpertenSelectorCallback: () => svs.matchen.views.drawDetail.contextMenu.clickXpert()
    });
  },
  initBetslip() {
    this.betslip = new svs.matchen.objects.BetslipHandler({
      model: this.model
    });
  },
  initListeners() {
    this.listenTo(this.model.get('xperten'), 'change', this.onXpertenChange);
    this.listenTo(this.model.get('xperten'), 'request', this.onXpertenRequest);
    this.listenTo(this.model.get('xperten'), 'error', this.onXpertenError);
    this.listenTo(this.model.get('xperten'), 'sync', this.onXpertenSync);
    this.listenTo(this.model, 'paymentError', this.handleUnsuccessfulPayment);
    this.listenTo(this.model, 'paymentDone', this.handleSuccessfulPayment);
  },
  refreshXperten() {
    this.model.get('xperten').fetch();
    return true;
  },
  onXpertenRequest() {
    svs.components.loader.show();
  },
  onXpertenSync() {
    svs.components.loader.hide();
  },
  onXpertenError() {
    svs.components.loader.hide();
    svs.components.dialog.api.add(new svs.components.dialog.Confirm({
      branding: svs.components.dialog.branding.SPORT,
      icon: 'help-2',
      title: 'Det går tyvärr inte att spela på PIX! just nu',
      actions: [{
        title: 'Okej'
      }]
    }));
  },
  clearCouponCallback() {
    const dialog = new svs.components.dialog.Confirm({
      branding: svs.components.dialog.branding.SPORT,
      icon: 'help-2',
      title: 'Dina tecken kommer att rensas',
      message: [{
        type: svs.components.dialog.message.TEXT,
        text: 'Vill du fortsätta ändå?'
      }],
      actions: [{
        title: 'Avbryt'
      }, {
        title: 'Fortsätt',
        callback: () => {
          dialog.close();
          _.defer(() => {
            this.model.emptyCoupon();
          });
        }
      }]
    });
    svs.components.dialog.api.add(dialog);
  },
  handleUnsuccessfulPayment() {
    svs.sport.sport_common.showErrorDialog('Något gick tyvärr fel', 'Försök igen senare.');
  },
  showTipsInfoModal() {
    svs.components.Modal.show(svs.matchen.views.TipsInfo, {
      model: svs.matchen.tipsInfo
    }, {
      title: 'Tipsinfo',
      headerClass: 'matchen-modal-header',
      leftButton: {
        visible: false
      },
      rightButton: {
        cssClass: 'btn-transparent-inverted',
        callback() {
          _.defer(() => {
            this.model.setGoalAvgTrend(this.viewModel.goalAvgTrend);
            this.model.setSvenskaFolket(this.viewModel.svenskaFolket);
            this.model.displayActionBar(true);
          });
          return true;
        }
      }
    });
  },
  handleSuccessfulPayment(cost) {
    svs.components.sport.getPaymentDoneMessage({
      amount: cost,
      productName: 'Matchen',
      isRetailer: svs.matchen.data.isRetailerAdmin,
      okAction: () => {
        if (svs.core.detect.formfactor.mobile()) {
          this.bigStat = new svs.matchen.BigStat();
          this.bigStat.closeBigStat('#matchen-nav');
        }
        svs.matchen.router.navigate('/', true);
      }
    }, messageObject => {
      svs.components.dialog.api.add(new svs.components.dialog.Confirm(messageObject.paymentDoneDialogConfig));
    });
  },
  onXpertenChange() {
    this.model.deselectOutcomes();
    this.model.resetReductions();
    this.renderCoupon();
  },
  onRender() {
    this.renderCoupon();
  },
  onAttach() {
    this.renderCoupon();
  },
  renderCoupon() {
    const currentView = this.getRegion('coupon').currentView;
    let view;

    if (svs.utils.ns.isNamespace('svs.core.config.data.svsconfig.isSelfService') && svs.core.config.data.svsconfig.isSelfService === true) {
      document.querySelector('.selfservice-nav-btn').innerHTML = '<a href="/matchen" class="btn btn-100 btn-transparent-inverted" title="Till Matchen start"><span class="btn-link-text">Matchen start</span></a>';
    }
    if (currentView) {
      this.stopResizeEventBubbling(currentView);
    }
    if (this.model.get('xperten').isActive()) {
      view = new svs.matchen.views.CouponXperten({
        model: this.model.get('xperten'),
        results: this.model.get('results')
      });
    } else {
      view = new svs.matchen.views.CouponRegular({
        model: this.model
      });
    }

    this.bubbleResizeEvent(view);
    this.showChildView('coupon', view);
  },
  stopResizeEventBubbling(eventEmitter) {
    this.stopListening(eventEmitter, 'resize:tab:view');
  },
  bubbleResizeEvent(eventEmitter) {
    if (svs.core.detect.formfactor.mobile()) {
      this.listenTo(eventEmitter, 'resize:tab:view', function () {
        this.trigger('resize:tab:view');
      }, this);
    }
  },
  onDestroy() {
    svs.matchen.views.betslip = undefined;
    if (this.actionBarTipsInfo) {
      this.actionBarTipsInfo.destroy();
    }
    if (this.model) {
      this.model.onDestroy();
    }
    this.destroyView('betslip');

    if (svs.utils.ns.isNamespace('svs.core.config.data.svsconfig.isSelfService') && svs.core.config.data.svsconfig.isSelfService === true) {
      document.querySelector('.selfservice-nav-btn').innerHTML = '<a href="/" class="btn btn-100 btn-transparent-inverted" title="Till Start"><span class="btn-link-text">Till Start</span></a>';
    }
  },
  destroyView(propName, context) {
    context = context || this;
    if (context[propName]) {
      context[propName].destroy();
      context[propName] = null;
      delete context[propName];
    }
  }
});

 })(window);